import React, { useState } from "react";

const services = [
  {
    icon: (
      // Laverie : machine à laver avec hublot
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-8 h-8">
        <path strokeLinecap="round" strokeLinejoin="round" d="M3 3.75A.75.75 0 013.75 3h16.5a.75.75 0 01.75.75v16.5a.75.75 0 01-.75.75H3.75a.75.75 0 01-.75-.75V3.75z" />
        <circle cx="12" cy="13" r="4" strokeLinecap="round" strokeLinejoin="round" />
        <circle cx="12" cy="13" r="2" strokeLinecap="round" strokeLinejoin="round" />
        <path strokeLinecap="round" strokeLinejoin="round" d="M6 6h.01M8.5 6h.01M11 6h.01" />
      </svg>
    ),
    title: "Laveries Self-Service",
    desc: "Mise en place de laveries automatiques pour textiles (vêtements, couvertures, etc.), simples d’utilisation et accessibles 24h/24 et 7j/7",
    accent: "yellow",
  },
  {
    icon: (
      // Lavage automatique : engrenage + gouttes d'eau
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-8 h-8">
        <path strokeLinecap="round" strokeLinejoin="round" d="M9.594 3.94c.09-.542.56-.94 1.11-.94h2.593c.55 0 1.02.398 1.11.94l.213 1.281c.063.374.313.686.645.87.074.04.147.083.22.127.325.196.72.257 1.075.124l1.217-.456a1.125 1.125 0 011.37.49l1.296 2.247a1.125 1.125 0 01-.26 1.431l-1.003.827c-.293.241-.438.613-.43.992a7.723 7.723 0 010 .255c-.008.378.137.75.43.991l1.004.827c.424.35.534.955.26 1.43l-1.298 2.247a1.125 1.125 0 01-1.369.491l-1.217-.456c-.355-.133-.75-.072-1.076.124a6.47 6.47 0 01-.22.128c-.331.183-.581.495-.644.869l-.213 1.281c-.09.543-.56.94-1.11.94h-2.594c-.55 0-1.019-.398-1.11-.94l-.213-1.281c-.062-.374-.312-.686-.644-.87a6.52 6.52 0 01-.22-.127c-.325-.196-.72-.257-1.076-.124l-1.217.456a1.125 1.125 0 01-1.369-.49l-1.297-2.247a1.125 1.125 0 01.26-1.431l1.004-.827c.292-.24.437-.613.43-.991a6.932 6.932 0 010-.255c.007-.38-.138-.751-.43-.992l-1.004-.827a1.125 1.125 0 01-.26-1.43l1.297-2.247a1.125 1.125 0 011.37-.491l1.216.456c.356.133.751.072 1.076-.124.072-.044.146-.086.22-.128.332-.183.582-.495.644-.869l.214-1.28z" />
        <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
      </svg>
    ),
    title: "Systèmes de Lavage Automatique",
    desc: "Conception et fabrication de machines de lavage performantes adaptées aux besoins industriels et commerciaux.",
    accent: "blue",
  },
  {
    icon: (
      // Installation : clé + éclair
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-8 h-8">
        <path strokeLinecap="round" strokeLinejoin="round" d="M11.42 15.17L17.25 21A2.652 2.652 0 0021 17.25l-5.877-5.877M11.42 15.17l2.496-3.03c.317-.384.74-.626 1.208-.766M11.42 15.17l-4.655 5.653a2.548 2.548 0 11-3.586-3.586l6.837-5.63m5.108-.233c.55-.164 1.163-.188 1.743-.14a4.5 4.5 0 004.486-6.336l-3.276 3.277a3.004 3.004 0 01-2.25-2.25l3.276-3.276a4.5 4.5 0 00-6.336 4.486c.091 1.076-.071 2.264-.904 2.95l-.102.085m-1.745 1.437L5.909 7.5H4.5L2.25 3.75l1.5-1.5L7.5 4.5v1.409l4.26 4.26m-1.745 1.437l1.745-1.437m6.615 8.206L15.75 15.75M4.867 19.125h.008v.008h-.008v-.008z" />
      </svg>
    ),
    title: "Installation & Mise en Service",
    desc: "Installation complète des équipements et mise en fonctionnement des systèmes de lavage.",
    accent: "yellow",
  },
  {
    icon: (
      // Maintenance : clé à molette
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-8 h-8">
        <path strokeLinecap="round" strokeLinejoin="round" d="M21.75 6.75a4.5 4.5 0 01-4.884 4.484c-1.076-.091-2.264.071-2.95.904l-7.152 8.684a2.548 2.548 0 11-3.586-3.586l8.684-7.152c.833-.686.995-1.874.904-2.95a4.5 4.5 0 016.336-4.486l-3.276 3.276a3.004 3.004 0 002.25 2.25l3.276-3.276c.256.565.398 1.192.398 1.852z" />
      </svg>
    ),
    title: "Maintenance & Support Technique",
    desc: "Service après-vente, maintenance et assistance technique pour garantir la performance des installations.",
    accent: "blue",
  },
  {
    icon: (
      // Solutions sur mesure : règle + crayon de conception
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-8 h-8">
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 18v-5.25m0 0a6.01 6.01 0 001.5-.189m-1.5.189a6.01 6.01 0 01-1.5-.189m3.75 7.478a12.06 12.06 0 01-4.5 0m3.75 2.383a14.406 14.406 0 01-3 0M14.25 18v-.192c0-.983.658-1.823 1.508-2.316a7.5 7.5 0 10-7.517 0c.85.493 1.509 1.333 1.509 2.316V18" />
      </svg>
    ),
    title: "Solutions sur Mesure",
    desc: "Étude et conception de projets personnalisés de laveries selon les besoins du client.",
    accent: "yellow",
  },
];

const ServiceCard = ({ s, i }: { s: typeof services[0]; i: number }) => {
  const [clicked, setClicked] = useState(false);

  const handleClick = () => {
    setClicked(true);
    setTimeout(() => setClicked(false), 400);
  };

  return (
    <div
      onClick={handleClick}
      className={`group relative bg-white border border-gray-100 rounded-2xl p-6 sm:p-8 shadow-sm cursor-pointer
        hover:shadow-xl hover:-translate-y-1
        transition-all duration-300 overflow-hidden
        ${clicked ? "scale-105 shadow-2xl" : "scale-100"}
      `}
      style={{
        transform: clicked ? "scale(1.05)" : undefined,
        transition: "transform 0.25s cubic-bezier(.34,1.56,.64,1), box-shadow 0.3s ease",
      }}
    >
      {/* Bande colorée en haut */}
      <div className={`absolute top-0 left-0 right-0 h-1 rounded-t-2xl transition-all duration-300
        ${s.accent === "yellow" ? "bg-yellow-400" : "bg-blue-600"}
        ${clicked ? "h-2" : ""}
      `} />

      {/* Icône */}
      <div className={`mb-6 w-14 h-14 rounded-xl flex items-center justify-center transition-all duration-300
        ${clicked ? "scale-110 rotate-6" : "scale-100 rotate-0"}
        ${s.accent === "yellow"
          ? "bg-yellow-50 text-yellow-500 group-hover:bg-yellow-400 group-hover:text-white"
          : "bg-blue-50 text-blue-600 group-hover:bg-blue-600 group-hover:text-white"
        }`}
        style={{ transition: "transform 0.3s cubic-bezier(.34,1.56,.64,1)" }}
      >
        {s.icon}
      </div>

      {/* Titre */}
      <h3 className={`text-lg font-bold mb-3 transition-colors duration-300
        ${s.accent === "yellow"
          ? "text-yellow-500 group-hover:text-yellow-600"
          : "text-blue-600 group-hover:text-blue-700"
        }`}>
        {s.title}
      </h3>

      {/* Ligne déco */}
      <div className={`h-[2px] rounded-full mb-4 transition-all duration-300
        ${clicked ? "w-20" : "w-8 group-hover:w-14"}
        ${s.accent === "yellow" ? "bg-yellow-400" : "bg-blue-500"}`}
      />

      {/* Description */}
      <p className="text-gray-400 text-sm leading-relaxed">
        {s.desc}
      </p>

      {/* Ripple effect au clic */}
      {clicked && (
        <span className={`absolute inset-0 rounded-2xl animate-ping opacity-10
          ${s.accent === "yellow" ? "bg-yellow-400" : "bg-blue-500"}`}
          style={{ animationDuration: "0.4s" }}
        />
      )}
    </div>
  );
};

const Services = () => {
  return (
<div className="w-full bg-[#fcfaf6] py-16 sm:py-20 px-4 sm:px-6">
      {/* EN-TÊTE */}
      <div className="max-w-6xl mx-auto mb-16 text-center">
        <div className="flex items-center justify-center gap-3 mb-3">
          <span className="w-8 h-[2px] bg-yellow-400 rounded-full" />
          <span className="text-sm font-semibold tracking-[0.25em] uppercase text-gray-400">
            Ce que nous proposons
          </span>
        </div>
        <h3 className="text-4xl md:text-5xl font-black uppercase leading-tight mb-4 text-blue-600">
          Services &amp; Solutions
        </h3>
        <p className="text-gray-400 text-base max-w-2xl leading-relaxed mx-auto">
          J-Tronics propose des solutions complètes dans le domaine du lavage et des laveries self-service. Nous accompagnons nos clients dans la conception, l'installation et l'exploitation de systèmes de lavage modernes adaptés aux besoins professionnels et particuliers.
        </p>
      </div>

      {/* 3 premiers */}
      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {services.slice(0, 3).map((s, i) => (
          <ServiceCard key={i} s={s} i={i} />
        ))}
      </div>

      {/* 2 derniers centrés */}
<div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-6 mt-6 place-items-center">
          {services.slice(3, 5).map((s, i) => (
<div key={i} className="w-full max-w-md">
              <ServiceCard s={s} i={i + 3} />
          </div>
        ))}
      </div>

    </div>
  );
};

export default Services;